<!--
<div *ngIf="forwardError" class="row justify-content-between">
  <div class="col-12 center">
    <div class="warning">{{ forwardError }}</div>
  </div>
  <div class="col-12 center">
    <hr>
  </div>
</div>
-->
<div class="row justify-content-between">
  <div class="col-12 col-sm-5">
    <app-button *ngIf="!hideBack" [title]="(backTitle ? backTitle : 'Back') | translate" (clickEvent)="onBackwardClick()" [isLeftStyle]="true"></app-button>
  </div>
  <div class="col-12 col-sm-5">
    <app-button *ngIf="!hideNext" [title]="(nextTitle ? nextTitle : 'Next') | translate" (clickEvent)="onForwardClick()" [buttonCssClass]="cssClassForwardButton"></app-button>
  </div>
</div>
